import styled from 'styled-components'
import { colors } from '@chegg-ui/theme'
/**
 * Use Case: <SVGContainer />
 * Some libraries aren't working correctly with SVGs, one workaround we've
 * found is to use an HTML element to wrap the SVG. We usually use SVGs much
 * like we do images, and inline-block is the type of display that most
 * closely resembles an img tags default layout behavior.
 */
export const SVGContainer = styled.span`
  display: inline-block;
  line-height: 1;
`
export const TargetText = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  &:hover {
    text-decoration: underline;
  }
`

export const TooltipBody = styled.span`
  font-weight: 100;
`

export const TooltipContent = styled.span`
  @media (max-width: 542px) {
    width: min-content;
  }
`
